module.exports = __webpack_public_path__ + "img/receipt.f709a158.png";